import * as types from './actionTypes';
import DAWAResource from "../services/DAWAResource";
import DAWAResponseFormatter from "../services/DAWAResponseFormatter";

export function searchCompanyAddress(searchParams) {
    return (dispatch) => {
        return DAWAResource.addressSearch(
            searchParams.municipalityId,
            searchParams.regionId,
            searchParams.searchString
        )
            .then((data) => {
                dispatch(searchCompanyAddressSuccess(data));
            })
            .catch(err => {
                throw  err;
            });
    }
}

export function preloadAddresses(searchParams) {
    let address = null;
    return (dispatch) => {
        DAWAResource.get('adresser', searchParams.id)
            .then((addressResponse) => {
                address = DAWAResponseFormatter.convertAddressToAutoCompleteLike(addressResponse);
                dispatch(updateCompanyPreviewLocation(addressResponse));
            }).then(() => {
            return DAWAResource.addressSearch(
                searchParams.municipalityId,
                searchParams.regionId,
            )
        }).then((addresses) => {
            let filteredAddresses = DAWAResponseFormatter.extendAddressAutoComplete(addresses, address);
            dispatch(preloadAddressesSuccess(filteredAddresses));
            dispatch(changePreloadAddressStatus(true));
        }).catch(err => {
            throw  err;
        });

    }
}

export function getAddressDetails(addressId) {
    return (dispatch) => DAWAResource.get('adresser', addressId)
        .then((addressDetails) => {
            dispatch(getAddressDetailsSuccess(addressDetails));
            dispatch(updateCompanyPreviewLocation(addressDetails));
        })
        .catch(err => {
            throw  err;
        });
}

export function searchCompanyAddressSuccess(addresses) {
    return {type: types.SEARCH_COMPANY_ADDRESS, addresses};
}

export function clearCompanyAddressSearchResults() {
    return {type: types.CLEAR_ADDRESS_SEARCH_RESULT};
}

export function getAddressDetailsSuccess(addressDetails) {
    return {type: types.GET_ADDRESS_DETAILS_SUCCESS, addressDetails};
}

export function preloadAddressesSuccess(addresses) {
    return {type: types.PRELOAD_ADDRESSES_SUCCESS, addresses};
}

export function changePreloadAddressStatus(status) {
    return {type: types.CHANGE_PRELOAD_ADDRESS_STATUS, addressPreLoaded: status};
}

export function updateCompanyPreviewLocation(addressDetails) {
    return {type: types.UPDATE_COMPANY_PREVIEW_LOCATION, addressDetails};
}


// WEBPACK FOOTER //
// ./web/src/actions/addressSearchActions.js